if(typeof window.sharedData.authors != "undefined") {
    const vueAuthors = new Vue({
        el: '#vue_authors',
        data: {
            search: '',
            letters: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
            letter_selected: '',
            authors: window.sharedData.authors,
        },
        methods: {
            selectLetter(letter) {
                //this.search = '';
                this.letter_selected = letter;
            },

        },
        watch: {
            search: function (newSearch, oldSearch) {
                this.letter_selected = '';
            },

            letter_selected: function (oldLetter, newLetter) {
                this.search = '';
            },
        },
        computed: {
            filteredAuthors: function () {
                if (this.letter_selected != '') {
                    return Object.values(this.authors).filter(item => {
                        if (item.letter === this.letter_selected) {
                            return true;
                        }
                        return false;
                    });
                }


                return Object.values(this.authors).filter(item => {
                    return item.search.toLowerCase().indexOf(this.search.toLowerCase()) > -1
                });


            },

            groupedAuthors: function () {
                var grouped_authors = _.groupBy(this.filteredAuthors, 'letter');
                var grouped = _.sortBy(grouped_authors, function (author_group) {
                    return _.head(author_group).letter;
                })

                return grouped.map(function (letterGroup) {

                    var letterGroupSorted = _.sortBy(letterGroup, function (author) {
                        return author.lastname;
                    });

                    const n = 4;
                    const colItems = Math.ceil(letterGroup.length / n);

                    const result = [[], [], [], []]

                    for (let col = 0; col < n; col++) {
                        for (let i = 0; i < colItems; i++) {
                            const value = letterGroupSorted[i + col * colItems];
                            if (!value) continue
                            result[col].push(value)
                        }
                    }

                    return result;
                })
            }
        }
    });
}



// WEBPACK FOOTER //
// ./resources/js/frontend.authors.js